import { supabase } from '../supabase';

function ensureSupabase() {
  if (!supabase) throw new Error('Supabase n’est pas configuré');
}

function mapProfile(profile) {
  return {
    ...profile,
    _id: profile.id,
    firstName: profile.first_name,
    lastName: profile.last_name,
    dateOfBirth: profile.date_of_birth,
    photoURL: profile.photo_url,
    isAdmin: profile.is_admin
  };
}

export async function listProfiles() {
  ensureSupabase();
  const { data, error } = await supabase.from('profiles').select('*').order('email');
  if (error) throw error;
  return (data || []).map(mapProfile);
}

export async function updateProfile(id, values) {
  ensureSupabase();
  const payload = {};
  if (values.email !== undefined) payload.email = values.email;
  if (values.firstName !== undefined) payload.first_name = values.firstName;
  if (values.lastName !== undefined) payload.last_name = values.lastName;
  if (values.dateOfBirth !== undefined) payload.date_of_birth = values.dateOfBirth || null;
  if (values.gender !== undefined) payload.gender = values.gender || '';
  if (values.country !== undefined) payload.country = values.country || '';
  if (values.phone !== undefined) payload.phone = values.phone || '';
  if (values.isAdmin !== undefined) payload.is_admin = values.isAdmin;
  const { data, error } = await supabase.from('profiles').update(payload).eq('id', id).select('*').single();
  if (error) throw error;
  return mapProfile(data);
}

export async function listReports() {
  ensureSupabase();
  const { data, error } = await supabase
    .from('reports')
    .select('*, event:events(*, organizer:profiles!events_organizer_id_fkey(*)), reportedBy:profiles!reports_reported_by_fkey(*)')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data || []).map(report => ({
    ...report,
    _id: report.id,
    createdAt: report.created_at,
    event: report.event ? { ...report.event, _id: report.event.id, sportType: report.event.sport_type } : null,
    reportedBy: report.reportedBy ? mapProfile(report.reportedBy) : null
  }));
}

export async function deleteReport(id) {
  ensureSupabase();
  const { error } = await supabase.from('reports').delete().eq('id', id);
  if (error) throw error;
}

export async function deleteProfile(id) {
  ensureSupabase();
  const { error } = await supabase.rpc('admin_delete_user', { target_user_id: id });
  if (error) throw error;
}

export async function createUser(values) {
  ensureSupabase();
  const { data, error } = await supabase.rpc('admin_create_user', {
    user_email: values.email,
    user_password: values.password,
    user_first_name: values.firstName,
    user_last_name: values.lastName,
    user_date_of_birth: values.dateOfBirth || null,
    user_gender: values.gender || '',
    user_country: values.country || '',
    user_phone: values.phone || '',
    user_is_admin: Boolean(values.isAdmin)
  });
  if (error) throw error;
  return data;
}